<template>
  <div>
    <div
      class="item"
      :class="{ active: isavtive == index }"
      v-for="(item, index) in list"
      :key="index"
      @click="navid(item.id, index)"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array,
      default: {},
    },
  },
  data() {
    return {
      isavtive: 0,
    }
  },
  created() {},
  mounted() {},
  methods: {
    navid(e, s) {
      this.isavtive = s
      this.$emit('navid', e, s)
    },
  },
}
</script>
 
<style lang="less" scoped>
.item {
  cursor: pointer;
  width: 2.5rem;
  height: 1.03rem;
  line-height: 1.03rem;
  background: #ffffff;
  border: 0.03rem solid #597e07;
  text-align: center;
  border-radius: 0.51rem;
  margin-bottom: 0.28rem;
  font-size: 0.38rem;
  font-family: OPPOSans;
  font-weight: bold;
  color: #597e07;
  &.active {
    background: #a0c95c;
    color: #fff;
  }
  &:hover {
    background: #a0c95c;
    color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Navitem.vue